import React from 'react'
import { Outlet } from 'react-router-dom'

function MainInvoiceOutgoing() {
  return (
      <div>
          <Outlet/>
        </div>
  )
}

export default MainInvoiceOutgoing
